import React from "react";

import Cotizacion2 from "./Cotizacion2Renovacion";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { consultarPlacaFetch } from "../../../../redux/actions/aCotizacion";
import { runInThisContext } from "vm";
import { PermisosCotizadores } from "../../../../constants";
import ErrorPage from "../../../../components/ErrorPage";
//import Perfil from "components/Perfil/Perfil";
//import Rcontrasena from "components/Login/Recuperar_contrasena";
//import Camcontrasena from "components/Perfil/Cambiar_contrasena";

class ContainerCotizacion extends React.Component {

  getIdentifier(){
    // guardar el identificador del cotizador actual
    const queryParams = new URLSearchParams(this.props.location.search);
    // acceder al parametro de url
    let codigoProductoEspecial = queryParams.get("codigoProductoEspecial");
    if (codigoProductoEspecial === null ||  (codigoProductoEspecial !='vehiculosKilometrosPaquete' && codigoProductoEspecial !='comparador' && codigoProductoEspecial !='externo' && codigoProductoEspecial !='KilometrosConsumidos' && codigoProductoEspecial !='pits')) {
      codigoProductoEspecial = '';
    }
    // return
    return codigoProductoEspecial;
  }

  constructor(props) {
    super(props);
    this.state = {
      codigoProductoEspecial: this.getIdentifier(),
    };
  }

  componentDidMount() {
    /*
  chasis:this.props.datosCotizacion.datosPlaca.chasis,
  cedula:this.props.datosCotizacion.datosPersona.cedula,
  marca:this.props.datosCotizacion.datosPlaca.marca,
  anio:this.props.datosCotizacion.datosPlaca.anio,
  modelo:this.props.datosCotizacion.datosPlaca.modelo,
  tipo:this.props.datosCotizacion.datosPlaca.tipo,
  rastreo:false,
  nombre:this.props.datosCotizacion.datosPersona.nombre,
  fechaNacimiento:this.props.datosCotizacion.datosPersona.fechaNacimiento,
  estadoCivil:this.props.datosCotizacion.datosPersona.estadoCivil,
  genero:this.props.datosCotizacion.datosPersona.genero



  let datosCarrito={
    empresa:"",
    plataforma:"",
    cliCodigoCore:"",
    accion="",
    datosProducto:this.props.datosCotizacion.datosPlaca,
    datosCoberturas:{},
    datosAmparos:
  }*/
  }

  render() {
    return (
      this.state.codigoProductoEspecial !='' ?
      <main class="cr-app bg-light">
        <div class="cr-content container-fluid">
          <div className="container-body-spaces">
            <Cotizacion2
              datosCotizacion={this.props.datosCotizacion}
              territorios={this.props.catalogosCotizacion.territorios}
            />
          </div>
        </div>
      </main> :
      <ErrorPage mainText={PermisosCotizadores.msgSinProductoAuto } />
    );
  }
}

const mapStateToProps = (state) => ({
  //userIsLoggedIn: state.datosUsuarios.dataUsuario.userIsLoggedIn,
  datosCotizacion: state.datosCotizacion,
  catalogosCotizacion: state.catalogosCotizacion,
});

const mapDispatchToProps = (dispatch) => {
  return {
    consultarPlaca: (placa) => dispatch(consultarPlacaFetch(placa)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ContainerCotizacion)
);
